export default {
  strict: true,
  namespaced: true,
  state: {
    logs: {
      list: [],
      order: 'created',
      maxList: 0,
      currentPage: 1,
      perPage: 15,
      orderAsc: 1,
      loading: false
    }
  },
  mutations: {
    resetLogs (state) {
      state.logs.list = []
    },
    setLogs (state, value) {
      state.logs.list = value
    },
    addCorporateLog (state, value) { state.logs.list.push(value) },
    setLoadingLogs (state, value) { state.logs.loading = value },
    setCorporateLogsCurrentPage (state, value) { state.logs.currentPage = value },
    setCorporateLogsMaxList (state, value) { state.logs.maxList = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/corporate/logs.js